<template>
<div class="specialSettingDialog">
    <el-dialog @close="cancel" title="题库设置" :visible.sync="dialogVisible" width="962px">
        <el-table :data="tableData" style="width: 100%" >
            <el-table-column prop="subjectname" label="科目名称" min-width="150px" show-overflow-tooltip>
                <template slot-scope="scope"><div class="text-ellipse">{{scope.row.subjectname}}</div></template>
            </el-table-column>
            <el-table-column prop="sectionname" label="板块名称" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="datatypename" label="数据类型" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="qbinnerid" label="题库ID" min-width="120px" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="qbhostinnerid" label="机构ID" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="qbcatecode" label="题库分类" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="qbsectioncode" label="题库板块" class-name="tc" label-class-name="tc"></el-table-column>
        </el-table>
    </el-dialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbanktopicconfig} from 'api/questionApi'
export default {
    name: 'specialSettingDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            param: {
                examcode: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        openDialog(row) {
            this.param.examcode = row.examcode
            this.tableData = []
            this._getList()
            this.dialogVisible = true
        },
        _getList() {
            this.setLoading(true)
            getQuestionbanktopicconfig({
                data: Object.assign({}, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialSettingDialog {
    .tc{
        .cell{
            text-align: center;
        }
    }
}
</style>
